
import {settings} from './settings.mjs';

if (typeof(settings) === 'undefined'){
    console.log('ERROR HERE');
} 

const canvas = document.getElementById("canvas");
//const p = document.getElementById("time");
const ctx = canvas.getContext("2d");
let radius = canvas.height / 2;
ctx.translate(radius, radius);
radius = radius * 0.90

export function drawClock(h=null, m=null, s=null, type) {
        
    switch (type) {
        case 'digital':
            drawDigital(h, m);
            break;
        default:
            drawFace(ctx, radius);
            drawNumbers(ctx, radius);
            drawTime(ctx, radius, h, m, s);
            break;
    }
}


function drawDigital(h, m) {
    // https://freefrontend.com/javascript-clocks/
    let digitalFont = new FontFace(
        //"Orbitron",
        // "url(https://fonts.gstatic.com/s/orbitron/v35/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6BoWgz.woff2)"
        "Seven Segment",
        'url("https://fonts.cdnfonts.com/s/71640/Seven Segment.woff")'
        );
    digitalFont.load().then((font) => {
        h = (h < 10) ? "0" + h : h;
        m = (m < 10) ? "0" + m : m;

        document.fonts.add(font);
        ctx.font = "120px Seven Segment";
        ctx.fillStyle = '#095666ff';
        ctx.translate(-(canvas.width/3), 0);
        ctx.fillText(h + ':' + m, 0, 0);
    });
   
    //ctx.transform(-0.5, -0.5, 0, 0, 0, 0);
}

function drawFace(ctx, radius) {
    const grad = ctx.createRadialGradient(0,0,radius*0.95, 0,0,radius*1.05);
    grad.addColorStop(0, '#333');
    grad.addColorStop(0.5, 'white');
    grad.addColorStop(1, '#333');
    ctx.beginPath();
    ctx.arc(0, 0, radius, 0, 2*Math.PI);
    ctx.fillStyle = 'white';
    ctx.fill();
    ctx.strokeStyle = grad;
    ctx.lineWidth = radius*0.1;
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(0, 0, radius*0.1, 0, 2*Math.PI);
    ctx.fillStyle = '#333';
    ctx.fill();
}

function drawNumbers(ctx, radius) {
    ctx.font = radius*0.14 + "px arial";
    ctx.textBaseline="middle";
    ctx.textAlign="center";
    for(let num = 1; num < 13; num++){
        let ang = num * Math.PI / 6;
        ctx.rotate(ang);
        ctx.translate(0, -radius*0.85);
        ctx.rotate(-ang);
        ctx.fillText(num.toString(), 0, 0);
        ctx.rotate(ang);
        ctx.translate(0, radius*0.85);
        ctx.rotate(-ang);
    }
    ctx.font = radius*0.14 + "px arial";
    for(let tick = 0; tick < 60; tick++){
        //skip if number
        if (tick % 5 == 0) continue;
            let ang = tick * Math.PI / 30;
            ctx.rotate(ang);
            ctx.translate(0, -radius*0.86);
            ctx.rotate(-ang);
            ctx.fillText(String.fromCharCode(parseInt('00B7', 16)), 0, 0);
            ctx.rotate(ang);
            ctx.translate(0, radius*0.86);
            ctx.rotate(-ang);
    }
}

function drawTime(ctx, radius, h, m, s){
    const now = new Date();
    let hour = h ?? now.getHours();
    let minute = m ?? now.getMinutes();
    let second = s ?? now.getSeconds();
    //printTime(hour, minute, second); //nrb
    //hour
    hour=hour%12;
    hour=(hour*Math.PI/6)+
    (minute*Math.PI/(6*60))+
    (second*Math.PI/(360*60));
    drawHand(ctx, hour, radius*0.5, radius*0.07);
    //minute
    minute=(minute*Math.PI/30)+(second*Math.PI/(30*60));
    drawHand(ctx, minute, radius*0.8, radius*0.07);
    // second
    if (settings.clockShowSeconds){
        second=(second*Math.PI/30);
        drawHand(ctx, second, radius*0.9, radius*0.02);
    }
    
    
}


function drawHand(ctx, pos, length, width) {
    ctx.beginPath();
    ctx.lineWidth = width;
    ctx.lineCap = "round";
    ctx.moveTo(0,0);
    ctx.rotate(pos);
    ctx.lineTo(0, -length);
    ctx.stroke();
    ctx.rotate(-pos);
}

